import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme) => ({
  propertiesHeader: {
    display: 'block',
    width: '100%',
    alignItems: 'center',
    '@media (min-width:356px)': {
      display: 'inline-flex'
    }
  },

  propertiesHeaderContent: {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',

    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      alignItems: 'start'
    }
  },

  buttonContainer: {
    display: 'flex',
    gap: '10px',
    marginBottom: '-2px',
    paddingLeft: '10px',
    zIndex: 1,
    [theme.breakpoints.down('sm')]: {
      paddingLeft: '0',
      marginTop: '8px',
      flexDirection: 'column',
      width: '100%'
    }
  },

  buttonWrapper: {
    width: 'max-content',
    display: 'flex',
    padding: '8px 16px 8px 12px',
    gap: '8px',

    [theme.breakpoints.down('sm')]: {
      width: '100%'
    }
  },

  buttonOutlined: {
    backgroundColor: 'transparent',
    border: `1px solid ${theme.palette.primary.main}`,
    color: theme.palette.primary.main
  },

  propertiesContainer: {
    padding: '16px 0',
    display: 'flex',
    flexDirection: 'column'
  },

  propertiesPopup: {
    '& .popup__box': {
      height: 'auto',
      maxWidth: 845
    }
  }
}))
